import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SupplierService } from '../../../services/supplier.service';
import { Supplier } from '../../../models/supplier.model';
import { CreateSupplierDto } from '../../../models/dtos/createSupplier.dto';
import { StateService } from '../../../services/state.service';
import { CityService } from '../../../services/city.service';
import { State } from '../../../models/state.model';
import { City } from '../../../models/city.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-form-supplier',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    SelectModule,
    ButtonModule,
    CheckboxModule,
    InputMaskModule
  ],
  templateUrl: './form-supplier.component.html'
})
export class FormSupplierComponent implements OnInit {

  form!: FormGroup;
  isEditMode = false;
  id!: number;
  returnTo: string | null = null;

  states: State[] = [];
  cities: City[] = [];

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private supplierService: SupplierService,
    private stateService: StateService,
    private cityService: CityService,
    private router: Router
  ) {}

  @HostListener('document:keydown.f7', ['$event'])
  onF7(event: Event): void {
    event.preventDefault();
    this.onSubmit();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      companyName: ['', Validators.required],
      tradingName: [''],
      cnpj: [''],
      stateRegistration: [''],
      zipCode: [''],
      address: [''],
      addressNumber: [''],
      addressComplement: [''],
      district: [''],
      state: [''],
      city: [''],
      phone: [''],
      mobilePhone: [''],
      whatsApp: [''],
      email: [''],
      active: [true]
    });

    this.getStates();

    this.returnTo = this.activatedRoute.snapshot.queryParamMap.get('returnTo');

    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam, 10);
      this.isEditMode = true;
      this.supplierService.getById(this.id).subscribe({
        next: (data) => {
          const s = data.data;
          if (s?.state) {
            this.getCities({ value: s.state });
          }
          this.form.patchValue({
            companyName: s?.companyName ?? '',
            tradingName: s?.tradingName ?? '',
            cnpj: s?.cnpj ?? '',
            stateRegistration: s?.stateRegistration ?? '',
            zipCode: s?.zipCode ?? '',
            address: s?.address ?? '',
            addressNumber: s?.addressNumber ?? '',
            addressComplement: s?.addressComplement ?? '',
            district: s?.district ?? '',
            state: s?.state ?? '',
            city: s?.city ?? '',
            phone: s?.phone ?? '',
            mobilePhone: s?.mobilePhone ?? '',
            whatsApp: s?.whatsApp ?? '',
            email: s?.email ?? '',
            active: s?.active ?? true
          });
        },
        error: (err) => console.error(err)
      });
    }
  }

  getStates(): void {
    this.stateService.getAll('', false, null).subscribe({
      next: (result) => this.states = result.data ?? []
    });
  }

  getCities(event: any): void {
    const uf = event?.value ?? event;
    if (!uf) return;
    this.cityService.getAll('', null, uf, false, null).subscribe({
      next: (data) => this.cities = data.data ?? []
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  goBack(): void {
    if (this.returnTo) {
      this.router.navigateByUrl(this.returnTo);
    } else {
      this.router.navigate(['/app/suppliers']);
    }
  }

  onSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => this.form.get(key)?.markAsTouched());
      return;
    }

    const value = this.form.getRawValue();

    if (this.isEditMode) {
      const supplier: Supplier = { ...value, id: this.id };
      this.supplierService.update(this.id, supplier).subscribe({
        next: () => this.goBack(),
        error: (err) => console.error(err)
      });
    } else {
      const dto: CreateSupplierDto = { ...value };
      this.supplierService.create(dto).subscribe({
        next: () => this.goBack(),
        error: (err) => console.error(err)
      });
    }
  }
}
